<div class="container">
  <onyx-information-heading>
    {{ `${I18N}.paymentsHistory` | translate }}
  </onyx-information-heading>

  <onyx-table
    [data]="paymentsHistoryData()"
    [columns]="columns()"
    [tableShadow]="false"
    [rowOptions]="getPaymentOptions"
  ></onyx-table>
</div>
